import React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { Container, Tabs, Tab } from "react-bootstrap"
import Charger from "../Charger"


const query = graphql`
{
  allStrapiChargers {
    nodes {
      producer
      model
      image {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      plug {
        icon
        name
        desc
        modalimage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      power {
        power
        chargertype {
          plug
          powertype
        }
      }
    }
  }
}`

const Chargers = () => {
    const { allStrapiChargers: { nodes: chargers } } = useStaticQuery(query);
        return (
        <section className="section-ladowarki">
        <Container>
            <Tabs
                defaultActiveKey={chargers[0].producer}
                variant="pills"
                id="chargers"
                className="justify-content-center"
            >
                {chargers.map((node,i) => {
                    return <Tab eventKey={node.producer} title={node.producer} key={`tab-${i}`}>
                        <Charger data={node} />
                    </Tab>
                })}
            </Tabs>             
        </Container>
        </section>
    )
}

export default Chargers
